/** Shows "已下线" / "无权限" for historical Canvas nodes that remain on the
 * board but are no longer creatable or executable (VistoeraTASK-00634). */
import { Tag } from 'antd'
import { useSyncExternalStore } from 'react'
import {
  getAuthMatrixRevision,
  isNodeAuthDenied,
  subscribeAuthMatrix,
} from './authMatrixRuntime'
import {
  getNodeCatalogRevision,
  isNodeOfflineInCatalog,
  subscribeNodeCatalog,
} from './nodeCatalogRuntime'

export default function OfflineNodeBadge({ nodeType }: { nodeType: string }) {
  useSyncExternalStore(subscribeNodeCatalog, getNodeCatalogRevision, getNodeCatalogRevision)
  useSyncExternalStore(subscribeAuthMatrix, getAuthMatrixRevision, getAuthMatrixRevision)
  if (isNodeOfflineInCatalog(nodeType)) {
    return (
      <Tag color="default" style={{ margin: 0, fontSize: 10, lineHeight: '16px' }}>
        已下线
      </Tag>
    )
  }
  if (isNodeAuthDenied(nodeType)) {
    return (
      <Tag color="orange" style={{ margin: 0, fontSize: 10, lineHeight: '16px' }}>
        无权限
      </Tag>
    )
  }
  return null
}
